<template>
  <div class="form-horizontal">
    <div class="form-group">
        <label class="col-sm-2 control-label">姓名</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="姓名" v-model="user.profile.name" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">手机</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="手机" v-model="user.profile.phone" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">地址</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="地址" v-model="user.profile.address" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">性别</label>
        <div class="col-sm-10">
          <select class="form-control" v-model="user.profile.sex" disabled>
            <option value="女">女</option>
            <option value="男">男</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">卡号</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="卡号" v-model="user.profile.vipID" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">余额</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="余额" v-model.number="user.profile.balance" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">应收金额</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="price" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">现金</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromCash" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">支付宝</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromAlipay" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">微信</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromWechat" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">使用会员卡余额</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromVip" :disabled="mode==='view' || !user.profile.vipID">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label"></label>
        <div class="col-sm-10">
          <btn type="primary" @click="doPay">确认付款</btn>
          <btn type="primary" @click="gotoRecharge">前往充值</btn>
        </div>
      </div>
  </div>
</template>

<script>
import * as T from '../store/types'
export default {
  data() {
    return {
      type: 'clothe',
      id: '',
      fee: {},
      mode: 'payment'
    }
  },
  computed: {
    price() {
      if (this.type === 'clothe') {
        return this.payment.price
      }
      let sum = 0
      if (this.$store.state.tickets.payment.ticket.clotheRecords) {
        this.$store.state.tickets.payment.ticket.clotheRecords.map((val, index) => {
          if (!val.hasPay) {
            sum += val.price
          }
        })
      }
      return sum
    },
    payment() {
      if (this.type === 'clothe') {
        return this.$store.state.clothe.payment.clothe
      }
      if (this.type === 'ticket') {
        return this.$store.state.tickets.payment.ticket
      }
    },
    user() {
      if (this.type === 'clothe') {
        return this.$store.state.clothe.payment.clothe.ticket.user
      }
      if (this.type === 'ticket') {
        return this.$store.state.tickets.payment.ticket.user
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    gotoRecharge() {
      this.$router.push('/recharge/' + this.user.profile.phone)
    },
    fetch() {
      const type = this.$route.params.type
      const id = this.$route.params.idView
      this.type = type
      this.id = id
      console.log(this.id)
      if (this.type === 'clothe') {
        this.$store.dispatch(T.DO_GET_CLOHTE, id)
      } else {
        this.$store.dispatch(T.DO_GET_TICKET, this.id)
      }
    },
    doPay() {
      if (this.fee.fromCash === '') {
        this.fee.fromCash = 0
      }
      if (this.fee.fromVip === '') {
        this.fee.fromVip = 0
      }
      if (this.fee.fromAlipay === '') {
        this.fee.fromAlipay = 0
      }
      if (this.fee.fromWechat === '') {
        this.fee.fromWechat = 0
      }
      if (this.type === 'clothe') {
        this.$store.dispatch(T.DO_PAY_CLOTHE, {
          id: this.id,
          fee: this.fee
        })
        .then(res => {
          console.log('pay succesed')
          this.$notify({
            'type': 'success',
            'content': `成功为衣服[${this.payment.name}]付款`
          })
          this.$router.back()
        })
        .catch(res => {
          console.log(res)
          this.$notify({
            'type': 'danger',
            'content': res.data.msg
          })
        })
      }
      if (this.type === 'ticket') {
        if ((this.fee.fromCash || 0) + (this.fee.fromWechat || 0) + (this.fee.fromAlipay || 0) + (this.fee.fromVip || 0) !== this.price) {
          this.$notify({
            type: 'warning',
            content: '请输入正确的金额'
          })
          return
        }
        this.$store.dispatch(T.DO_PAY_TICKET, {
          id: this.payment.id,
          fee: this.fee
        })
        .then(res => {
          this.$notify({
            'type': 'success',
            'content': `成功为衣单[${this.payment.idView}]付款`
          })
          // this.fetch()
          this.$router.back()
        })
        .catch(res => {
          console.log(res)
          this.$notify({
            'type': 'danger',
            'content': res.data.msg
          })
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Payment.vue